import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Transition as _Transition } from "vue";
import _imports_0 from '@/assets/logo.png';
const _hoisted_1 = {
  class: "mobile-menu-area"
};
const _hoisted_2 = {
  class: "navbar-right"
};
const _hoisted_3 = {
  class: "language-text"
};
const _hoisted_4 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_Fold = _resolveComponent("Fold");
  const _component_Expand = _resolveComponent("Expand");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_Operation = _resolveComponent("Operation");
  const _component_ArrowDown = _resolveComponent("ArrowDown");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_header = _resolveComponent("el-header");
  return _openBlock(), _createBlock(_component_el_header, {
    class: "navbar-content",
    style: _normalizeStyle({
      height: $data.navbarHeight
    }),
    onSelect: $options.handleSelect
  }, {
    default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("img", {
      src: _imports_0,
      class: "logo",
      alt: "Logo"
    }, null, -1)), _createVNode(_component_el_menu, {
      "default-active": _ctx.$route.path,
      router: true,
      class: "navbar-menu desktop-menu",
      mode: "horizontal",
      ellipsis: false
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "/"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.home')), 1)]),
        _: 1
      }), $options.hasAnyBrandFeature ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 0,
        index: "brand-tools"
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.brandTools')), 1)]),
        default: _withCtx(() => [$options.authStore.hasFeature('dashboard') ? (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 0,
          index: "/brand/dashboard"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.brandDashboard')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), $options.authStore.hasFeature('colors') ? (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 1,
          index: "/wrap-colors"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.wrapColors')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), $options.authStore.hasFeature('training') ? (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 2,
          index: "/training"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.training')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), $options.authStore.hasFeature('leads') ? (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 3,
          index: "/brand/leads"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.customerLeads')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), $options.authStore.hasFeature('store') ? (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 4,
          index: "/brand/stores"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.storeManagement')), 1)]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })) : _createCommentVNode("", true), $options.authStore.isLoggedIn ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        index: "/render"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.render')), 1)]),
        _: 1
      })) : _createCommentVNode("", true), $options.authStore.isLoggedIn ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 2,
        index: "/history"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.history')), 1)]),
        _: 1
      })) : _createCommentVNode("", true), $options.authStore.isLoggedIn ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 3,
        index: "/activation-code"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.activationCode')), 1)]),
        _: 1
      })) : _createCommentVNode("", true), $options.authStore.isAdminAccount || $options.authStore.isDistributorAccount ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 4,
        index: "/sub-account"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($options.authStore.isDistributorAccount ? $setup.t('navbar.assignTokens') : $setup.t('navbar.subAccount')), 1)]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_menu_item, {
        index: "/terms"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.terms')), 1)]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
      class: "hamburger-btn",
      onClick: _cache[0] || (_cache[0] = $event => $data.mobileMenuOpen = !$data.mobileMenuOpen),
      text: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, {
        size: 22
      }, {
        default: _withCtx(() => [$data.mobileMenuOpen ? (_openBlock(), _createBlock(_component_Fold, {
          key: 0
        })) : (_openBlock(), _createBlock(_component_Expand, {
          key: 1
        }))]),
        _: 1
      })]),
      _: 1
    })]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_dropdown, {
      onCommand: $options.handleLanguageChange,
      class: "language-switcher",
      trigger: "click"
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
          class: _normalizeClass({
            'is-active': $setup.currentLanguage === 'zh'
          }),
          command: "zh"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('language.chinese')), 1)]),
          _: 1
        }, 8, ["class"]), _createVNode(_component_el_dropdown_item, {
          class: _normalizeClass({
            'is-active': $setup.currentLanguage === 'en'
          }),
          command: "en"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('language.english')), 1)]),
          _: 1
        }, 8, ["class"])]),
        _: 1
      })]),
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "text",
        class: "language-button"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Operation)]),
          _: 1
        }), _createElementVNode("span", _hoisted_3, _toDisplayString($setup.currentLanguage === 'zh' ? '中文' : 'EN'), 1), _createVNode(_component_el_icon, {
          class: "arrow-icon"
        }, {
          default: _withCtx(() => [_createVNode(_component_ArrowDown)]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["onCommand"]), $options.authStore.isLoggedIn ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_dropdown, {
      onCommand: $options.handleCommand
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
          command: "account"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.accountManagement')), 1)]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "logout"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.logout')), 1)]),
          _: 1
        })]),
        _: 1
      })]),
      default: _withCtx(() => [_createElementVNode("div", {
        class: "user-avatar",
        style: _normalizeStyle($options.avatarStyle)
      }, _toDisplayString($options.authStore.firstLetter), 5)]),
      _: 1
    }, 8, ["onCommand"])])) : (_openBlock(), _createBlock(_component_el_button, {
      key: 1,
      type: "primary",
      size: "small",
      onClick: $options.goToLogin
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.login')), 1)]),
      _: 1
    }, 8, ["onClick"]))]), _createVNode(_Transition, {
      name: "mobile-menu-fade"
    }, {
      default: _withCtx(() => [$data.mobileMenuOpen ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "mobile-dropdown",
        onClick: _cache[1] || (_cache[1] = $event => $data.mobileMenuOpen = false)
      }, [_createVNode(_component_router_link, {
        to: "/",
        class: _normalizeClass(["mobile-menu-item", {
          active: _ctx.$route.path === '/'
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.home')), 1)]),
        _: 1
      }, 8, ["class"]), $options.authStore.hasFeature('dashboard') ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: "/brand/dashboard",
        class: _normalizeClass(["mobile-menu-item", {
          active: _ctx.$route.path === '/brand/dashboard'
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.brandDashboard')), 1)]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true), $options.authStore.hasFeature('colors') ? (_openBlock(), _createBlock(_component_router_link, {
        key: 1,
        to: "/wrap-colors",
        class: _normalizeClass(["mobile-menu-item", {
          active: _ctx.$route.path === '/wrap-colors'
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.wrapColors')), 1)]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true), $options.authStore.hasFeature('training') ? (_openBlock(), _createBlock(_component_router_link, {
        key: 2,
        to: "/training",
        class: _normalizeClass(["mobile-menu-item", {
          active: _ctx.$route.path === '/training'
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.training')), 1)]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true), $options.authStore.hasFeature('leads') ? (_openBlock(), _createBlock(_component_router_link, {
        key: 3,
        to: "/brand/leads",
        class: _normalizeClass(["mobile-menu-item", {
          active: _ctx.$route.path === '/brand/leads'
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.customerLeads')), 1)]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true), $options.authStore.hasFeature('store') ? (_openBlock(), _createBlock(_component_router_link, {
        key: 4,
        to: "/brand/stores",
        class: _normalizeClass(["mobile-menu-item", {
          active: _ctx.$route.path === '/brand/stores'
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.storeManagement')), 1)]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true), $options.authStore.isLoggedIn ? (_openBlock(), _createBlock(_component_router_link, {
        key: 5,
        to: "/render",
        class: _normalizeClass(["mobile-menu-item", {
          active: _ctx.$route.path === '/render'
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.render')), 1)]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true), $options.authStore.isLoggedIn ? (_openBlock(), _createBlock(_component_router_link, {
        key: 6,
        to: "/history",
        class: _normalizeClass(["mobile-menu-item", {
          active: _ctx.$route.path === '/history'
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.history')), 1)]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true), $options.authStore.isLoggedIn ? (_openBlock(), _createBlock(_component_router_link, {
        key: 7,
        to: "/activation-code",
        class: _normalizeClass(["mobile-menu-item", {
          active: _ctx.$route.path === '/activation-code'
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.activationCode')), 1)]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true), $options.authStore.isAdminAccount || $options.authStore.isDistributorAccount ? (_openBlock(), _createBlock(_component_router_link, {
        key: 8,
        to: "/sub-account",
        class: _normalizeClass(["mobile-menu-item", {
          active: _ctx.$route.path === '/sub-account'
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($options.authStore.isDistributorAccount ? $setup.t('navbar.assignTokens') : $setup.t('navbar.subAccount')), 1)]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true), _createVNode(_component_router_link, {
        to: "/terms",
        class: _normalizeClass(["mobile-menu-item", {
          active: _ctx.$route.path === '/terms'
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('navbar.terms')), 1)]),
        _: 1
      }, 8, ["class"])])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["style", "onSelect"]);
}